import React from 'react'
import { FieldInputOption } from '../graphql/FormFieldCategory'

// @ts-ignore
export const getIsFirefox = () => {
  return (
    typeof window !== 'undefined' && /firefox/i.test(window.navigator.userAgent)
  )
}

export const fillOptions = (
  fieldLabel: string,
  options: FieldInputOption[]
) => {
  const optionArr: { label: string; value: string; disabled: boolean }[] = [
    { label: fieldLabel, value: fieldLabel, disabled: true }
  ]
  options.forEach((o: FieldInputOption) => {
    optionArr.push({
      label: o.optionLabel,
      value: o.optionValue,
      disabled: false
    })
  })

  return optionArr
}

// Helper Function to delete unnecessary fields from form data to allow submission to mkto
export const reformatData = (formData: any) => {
  const formId = formData.get('formid')
  switch (formId) {
    case '1014':
      formData.delete('craftInferredCountry')
      formData.delete('appendVariantTestText')
      formData.delete('craftFormLocation')
      formData.delete('craftJavascriptStatus')
      formData.delete('referringPageURLText')
      formData.delete('Web_initiative__c')
      formData.delete('Web_origin__c')
      formData.delete('Web_detail__c')
      formData.delete('Website_Source_Detail__c')
      formData.delete('Last_Blog_Seen__c')
      formData.delete('pageFormSubmissionURL')
      formData.delete('GCLID__c')
      formData.delete('postalCode')
    // eslint-disable-next-line no-fallthrough
    case '1008':
    case '1306':
      formData.delete('qQVersion')
      formData.delete('toastType')
      break
    default:
      break
  }

  return formData
}

export const postForm = (
  formData: FormData,
  formActionUrl?: string,
  extraOptions?: RequestInit
) => {
  // It looks like we need this step value to handle multi-step forms on the frontend
  // But the field doesn't exist in Marketo, so it crashes the form submission when present
  // Just delete it and move on
  formData.delete('step')

  formData = reformatData(formData)

  const url = formActionUrl || `${process.env.GATSBY_FORM_ACTION_URL}`
  const options: RequestInit = {
    body: formData,
    method: 'POST',
    mode: 'cors', // 'no-cors' for local submits
    ...extraOptions
  }

  return fetch(url, options)
}

export const getFormActionUrl = (formActionURL: string) => {
  let formAction = process.env.GATSBY_FORM_ACTION_URL

  if (
    formActionURL === 'marketo-integration/default/referral' ||
    formActionURL === 'marketo-integration/default/getmarketolead' ||
    formActionURL === 'marketo-integration/default/chilipiper' ||
    formActionURL === 'marketo-integration/default/chilipiperlegacy'
  ) {
    const actionURL = process.env.GATSBY_FORM_ACTION_URL.split('?action=')[0]
    formAction = `${actionURL}?action=${formActionURL}`
  }

  if (
    [
      'contentful-dev.phrasingpro3.com',
      'contentful-staging.phrasingpro3.com',
      'contentful-preview-dev.phrasingpro3.com',
      'contentful-preview-staging.phrasingpro3.com'
    ].includes(window.location.hostname)
  ) {
    if (formActionURL === 'marketo-integration/default/referral') {
      formAction = `?action=${formActionURL}`
    }
    let domain = 'https://staging.phrasingpro3.com'
    if (
      ['contentful-staging.phrasingpro3.com'].includes(window.location.hostname)
    ) {
      domain = `https://${window.location.hostname}/`
    }
    formAction = `${domain}${formAction}`
  }
  if (
    [
      'contentful-preview-master.phrasingpro3.com',
      'contentful-pos-proxy.phrasingpro3.com'
    ].includes(window.location.hostname)
  ) {
    formAction = `https://pos.toasttab.com${formAction}`
  }
  return formAction
}

export const getUtmParams = () => {
  const utmParams: any = {}

  const currentUrl = window.location.href
  let queryString = currentUrl
    ? currentUrl.split('?')[1]
    : window.location.search.slice(1)
  if (queryString) {
    queryString = queryString.split('#')[0]
    const arr = queryString.split('&')
    for (let i = 0; i < arr.length; i++) {
      const a = arr[i].split('=')
      const paramName = a[0]
      const paramValue: any = typeof a[1] === 'undefined' ? true : a[1]
      const qualifiers = [
        'utm_campaign',
        'utm_source',
        'utm_medium',
        'utm_term',
        'source',
        'gclid'
      ]
      if (qualifiers.indexOf(paramName) > -1) {
        utmParams[paramName] = paramValue
      }
    }
  }

  return utmParams
}

export const localizeFormError = (text: string, label: string): string => {
  return text
    .split(/({{fieldLabel}})/)
    .map((chunk) => {
      if (chunk === '{{fieldLabel}}') {
        return label
      }
      return chunk
    })
    .join('')
}

export const getBrowserLanguage = (): string => {
  if (typeof window === 'undefined') {
    return 'en' // Default for SSR
  }

  // Get the browser language (e.g., 'en-US', 'es-ES', 'fr-FR')
  const browserLang = navigator.language || navigator.languages?.[0] || 'en-US'

  // Extract just the language code (e.g., 'en' from 'en-US')
  const langCode = browserLang.split('-')[0].toLowerCase()

  return langCode
}
